import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getUrlString } from '@/helpers/UrlParam';

import copy from '@/../scripts/copy/out/index.json';

const resources = {};

for (const lang in copy) {
  resources[lang] = {
    translation: copy[lang],
  };
}

// const lng = window.location.pathname.split('/')[1];
const lng = getUrlString('language', 'en');

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources,
    lng, // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',
    returnEmptyString: true,

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });
